import React from "react";
import { ProfileImageStyled } from "./ProfileImageStyled";
import FarmerImage from "../FarmerImage";
var ProfileImage = function (_a) {
    var name = _a.name, image = _a.image;
    return (React.createElement(ProfileImageStyled, null,
        React.createElement(FarmerImage, { logoImg: image }),
        React.createElement("h1", null, name)));
};
export default ProfileImage;
//# sourceMappingURL=ProfileImage.js.map